import axiosInstant from "../axiosInstant"

  export async function login(ArrayData) {
      const response = await axiosInstant
        .post(`Login/`, ArrayData)
        .then((res) => {
           console.log("login console : ",res.data.sucess);
           if(res.data.sucess === true){
             return res.data
           }
          return res.data;
        })
        .catch((error) => {
        // console.log("login console : ",error.response.data.errors);
          // console.log(error.response.data.errors);
        return error.response.data
        });
      return response;
    }


    export async function forgetpassword(ArrayData) {
      try {
        const response = await axiosInstant.post(`user/reset-password`, ArrayData);
        const result = response.data;
    
        console.log("Reset password response:", result);
    
        return result;
      } catch (error) {
        console.error("Reset password error:", error?.response?.data || error.message);
    
        // Return a standard error object
        return {
          success: false,
          error: error?.response?.data || "An unexpected error occurred.",
        };
      }
    }


    export async function auctionsLive() {
      // //console.log('model auction: ',exhibition)
      const response = await axiosInstant
        .get(`live/current`)
        .then((res) => {
          // console.log('res.data.lot.detils: ',res.data)
          return res.data;
        })
        .catch((error) => {
        return error.response.data;
        });
      return response;
    }

    



